import { FC, ReactNode } from 'react';

export const ErrorMessage: FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <p className="absolute -bottom-[2px] left-[72px] translate-y-full pt-0.5 text-error">
      {children}
    </p>
  );
};
